import { env } from '@/env';
import { reducer as application } from '@/modules/application';
import { authReducer } from '@/modules/auth/services/slices/auth';
import { reducer as backendVersion } from '@/modules/backend-version/services/slices';
import { reducer as changelog } from '@/modules/changelog';
import { reducer as translate } from '@/modules/localizations';
import { reducer as messages } from '@/modules/messages';
import { reducer as modals } from '@/modules/modals';
import { reducer as network } from '@/modules/network';
import { reducer as secrets } from '@/modules/secrets';
import { reducer as wakeUp } from '@/modules/wake-up';

import api from './api';
import entities from './entities';

// NOTE:
// Do not use combineReducers() here,
// export reducers as plain object, not as a function.
const reducers = {
    auth: authReducer,
    translate,
    secrets,
    modals,
    messages,
    entities,
    api,
    network,
    changelog,
    application,
    backendVersion,
    ...(!env.VITE_DEMO && !env.VITE_SAAS ? { wakeUp } : {}),
};

export default reducers;
